"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MOBILE_HEADER_HEIGHT = void 0;
var react_1 = __importDefault(require("react"));
var BackArrow_1 = __importDefault(require("./BackArrow"));
var style_1 = require("./style");
Object.defineProperty(exports, "MOBILE_HEADER_HEIGHT", { enumerable: true, get: function () { return style_1.MOBILE_HEADER_HEIGHT; } });
var NavBar = function (_a) {
    var children = _a.children, className = _a.className, onClickBackButton = _a.onClickBackButton;
    return (react_1.default.createElement(style_1.Wrapper, { className: className },
        react_1.default.createElement("div", { className: 'NavBar__backButton', "data-test-id": 'backButton', onClick: onClickBackButton, role: 'button' },
            react_1.default.createElement(BackArrow_1.default, { className: 'NavBar__backArrow' })),
        react_1.default.createElement("div", { className: 'NavBar__logoWrapper' }, children)));
};
var defaultProps = {
    onClickBackButton: function () { }
};
NavBar.defaultProps = defaultProps;
exports.default = NavBar;
__exportStar(require("./types"), exports);
